import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import style from './style.module.scss';
function messageFor(reasonCode) {
    switch (reasonCode) {
        case 'SUBSCRIPTION_EXPIRED':
            return 'Подписка истекла. Облачные бюджеты доступны только для чтения.';
        case 'SUBSCRIPTION_PAST_DUE':
            return 'Проблема с оплатой подписки. Синхронизация приостановлена — облачные бюджеты только для чтения.';
        case 'CLOUD_SYNC_REVOKED':
        default:
            return 'Синхронизация приостановлена. Облачные бюджеты доступны только для чтения.';
    }
}
export default function SyncPausedBanner({ reasonCode }) {
    return (_jsxs("div", { className: style['banner'], role: "status", children: [_jsx("span", { className: style['icon'], "aria-hidden": "true", children: "\u23F8" }), _jsx("span", { className: style['text'], children: messageFor(reasonCode) })] }));
}
